import { BUTTON_LINK } from '../classnames/design-system';
import { addNavigationLoadingState } from '../shared/loading-state-helpers';

const getHref = (element) => {
  const ownHref = element.getAttribute && element.getAttribute('href');

  if (ownHref) {
    return ownHref;
  }

  const innerAnchor = element.querySelector && element.querySelector('a[href]');

  return innerAnchor ? innerAnchor.getAttribute('href') : null;
};

const opensNewContext = (element, event) => (
  element.target === '_blank'
  || event.metaKey
  || event.ctrlKey
  || event.shiftKey
  || event.button === 1
);

const willNavigate = (href) => {
  if (!href || href.startsWith('#')) {
    return false;
  }

  try {
    const url = new URL(href, window.location.href);

    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return false;
    }

    return url.origin !== window.location.origin
      || url.pathname !== window.location.pathname;
  } catch {
    return false;
  }
};

export default class ButtonLinks {
  handleClick = (event) => {
    const link = event.currentTarget;
    const href = getHref(link);

    if (!willNavigate(href) || opensNewContext(link, event)) {
      return;
    }

    addNavigationLoadingState(link);
  };

  addClickHandler = (link) => {
    link.addEventListener('click', this.handleClick);
  };

  initializeEventListeners = () => {
    document.querySelectorAll(`.${BUTTON_LINK}`).forEach(this.addClickHandler);
  };
}
